module.exports = __webpack_public_path__ + "assets/img/btn-view-6fe4d6c8.png";